import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/toPromise';
import { UploadFileService } from './upload-file.service';

export interface PDFParams {
  title: string;
  html: string;
  styleUrl: string;
}

export interface EmailParams {
  subject: string | null | undefined;
  message: string | null | undefined;
  to: string | null | undefined;
  cc: string | null | undefined;
  bcc: string | null | undefined;
}

export interface GetPathForConvertedPDFFileFromHTMLOptions {
  pageContent: string;
  width?: string;
  height?: string;
  topAndBottomMarginSize?: string;
  leftAndRightMarginSize?: string;
  generatedPDFName: string;
}

export interface GetPathForConvertedPDFFileFromHTMLResponse {
  filePath: string;
}

export interface ConvertHTMLToPDFOptions {
  pageContent: string;
  width?: string;
  height?: string;
  topAndBottomMarginSize?: string;
  leftAndRightMarginSize?: string;
}

export interface EmailWithMultipleAssetsOptions {
  email: EmailParams;
  assets: string;
}

export interface ConvertHTMLToPDFResponse {
  itemName: string;
  itemId: number;
  filePath: string;
}

declare let macs: any;

@Injectable()
export class PDFService {

  constructor(
    private http: Http,
    private uploadFileService: UploadFileService
  ) { }

  // Fetches the css
  private fetchStyle(styleUrl: string): Observable<string> {
    return new Observable<string>((observer) => {
      this.http
        .get(styleUrl)
        .pipe(
          map((res: any) => {
            observer.next(res.text());
            observer.complete();
          })
        )
        .toPromise();
    });
  }

  // Wrapes the compiled template
  private wrapHTML(html: string, css: string): string {
    let wrap = '<html>';
    if (css) {
      wrap += '<style>' + css + '</style>';
    }
    wrap += '<body class="md wp ios">' + html + '</body></html>';
    return wrap;
  }

  // Creates the PDF file and filePath
  createPDF(pdfParams: PDFParams): Observable<any> {
    return new Observable<any>((observer) => {

      this.createPDFHTML(pdfParams).subscribe((html) => {
        const that = this;

        // replace image links with base 64




        const xhttpRequest = new XMLHttpRequest();
        const callback = function (xhttp, context) {

          if (xhttp.readyState === 4 && xhttp.status === 200) {
            console.log(xhttp.response);

            // comes back a blob which we can upload to S3
            const key = `pdfUpload_${String(Math.round(Math.random() * 1000000000))}`;
            const itemBuffer = xhttp.response;

            context.uploadFileService.uploadfile(itemBuffer, key).then(
              (result) => {
                observer.next(result);
                observer.complete();
              }
            );
          }
        };
        xhttpRequest.onreadystatechange = function () { callback(xhttpRequest, that); };
        xhttpRequest.open(
          'POST',
          'https://v2.convertapi.com/html/to/pdf?secret=vaA2iu7JmSTKDSTo&download=inline',
          true
        );
        xhttpRequest.setRequestHeader('Content-type', 'application/octet-stream');
        xhttpRequest.setRequestHeader('Content-Disposition', 'inline; filename="pdf.html"');
        xhttpRequest.send(html);
        xhttpRequest.responseType = 'blob';
      });
    });
  }

  // Creates the PDF HTML
  createPDFHTML(pdfParams: PDFParams): Observable<string> {
    return new Observable<string>((observer) => {
      this.fetchStyle(pdfParams.styleUrl).subscribe((css) => {
        observer.next(this.wrapHTML(pdfParams.html, css));
        observer.complete();
      });
    });
  }

  // Create PDF and preview
  private previewMacsPDF(html: string, title: string): Observable<void> {
    return new Observable<void>((observer) => {

      const options: GetPathForConvertedPDFFileFromHTMLOptions = {
        pageContent: encodeURIComponent(html),
        generatedPDFName: title
      };

      macs.getPathForConvertedPDFFileFromHTML(
        options,
        (response: GetPathForConvertedPDFFileFromHTMLResponse) => {
          macs.viewAsset(
            response.filePath,
            () => {
              observer.next();
              observer.complete();
            }, (error: any) => observer.error(error)
          );
        },
        (error: any) => observer.error(error)
      );
    });

  }

  // Previews PDF
  previewPDF(pdfParams: PDFParams): Observable<string> {
    return new Observable<string>((observer) => {

      this.createPDFHTML(pdfParams).subscribe((html) => {
        observer.next();
        observer.complete();

      });

    });

  }

  // Saves a copy to CMS and previews
  savePDF(pdfParams: PDFParams, preview?: boolean): Observable<ConvertHTMLToPDFResponse> {
    return new Observable<ConvertHTMLToPDFResponse>((observer) => {

      this.createPDFHTML(pdfParams).subscribe((html) => {
        observer.next();
        observer.complete();

      });

    });

  }

  // Emails PDF as attachment (or link if > 5mb)
  emailPDF(pdfParams: PDFParams, emailParams: EmailParams, assets?: string[]): Observable<void> {
    return new Observable<void>((observer) => {

      assets = assets || [];

      // Compile HTML
      this.createPDFHTML(pdfParams).subscribe((html) => {
        observer.next();
        observer.complete();
      }

      );

    });
  }

}



// WEBPACK FOOTER //
// ./src/services/pdf.service.ts